import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";
import FilterMint from "../filters/FilterMint.vue";
import FilterAmount from "../filters/FilterAmount.vue";
import FilterPrice from "../filters/FilterPrice.vue";
import FilterLinkSignal from "../filters/FilterLinkSignal.vue";

// props
interface IProps {
	data?: any;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ActionLimitOrder',
  props: {
    data: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
	data?: any;
};



// computed
const FilterSourceMintRef = ref<InstanceType<typeof FilterMint> | null>(null);
const FilterDestinationMintRef = ref<InstanceType<typeof FilterMint> | null>(
	null
);
const FilterAmountRef = ref<InstanceType<typeof FilterAmount> | null>(null);
const FilterPriceRef = ref<InstanceType<typeof FilterPrice> | null>(null);
const isInvalid = computed<boolean>(
	() =>
		FilterSourceMintRef.value?.isInvalid ||
		FilterDestinationMintRef.value?.isInvalid ||
		FilterAmountRef.value?.isInvalid ||
		FilterPriceRef.value?.isInvalid
);
const getData = computed<any>(() => {
	return {
		mint: srcMint.value,
		src_mint: srcMint.value,
		dst_mint: dstMint.value,
		amount: amount.value,
		price: price.value,
	};
});

// data
const srcMint = ref<string>(props.data?.src_mint ?? "");
const dstMint = ref<string>(props.data?.dst_mint ?? "");
const amount = ref<number>(props.data?.amount ?? 0);
const price = ref<number>(props.data?.price ?? 0);

// expose
expose({ isInvalid, data: getData });

return { __sfc: true,props, FilterSourceMintRef, FilterDestinationMintRef, FilterAmountRef, FilterPriceRef, isInvalid, getData, srcMint, dstMint, amount, price, FilterMint, FilterAmount, FilterPrice, FilterLinkSignal }
}

})